var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.6533,
    height: 70.6533,
    rx: 12,
    fill: "#FFF0E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 41.0516L41.3085 37.4097L51.6041 47.7053L47.9622 51.3472L37.6666 41.0516ZM44.049 32.1709C47.3629 32.1709 50.0588 29.475 50.0588 26.1611C50.0588 25.1652 49.784 24.2379 49.3548 23.4137L44.7186 28.0499L42.1602 25.4914L46.7963 20.8553C45.9721 20.426 45.0449 20.1513 44.049 20.1513C40.735 20.1513 38.0392 22.8471 38.0392 26.1611C38.0392 26.8651 38.1765 27.5347 38.3998 28.1529L35.2232 31.3295L32.1667 28.2731L33.3859 27.0539L30.9648 24.6329L34.605 20.9926C33.6391 20.028 32.3299 19.4861 30.9648 19.4861C29.5997 19.4861 28.2904 20.028 27.3246 20.9926L21.2461 27.0711L23.6672 29.4922H18.825L17.6059 30.7113L23.6844 36.7898L24.9035 35.5707V30.7113L27.3246 33.1324L28.5437 31.9133L31.6001 34.9697L18.8765 47.6933L22.5167 51.3335L42.0571 31.8103C42.6753 32.0335 43.345 32.1709 44.049 32.1709Z",
    fill: "#FF832B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectHome);
export default __webpack_public_path__ + "static/media/projectHome.ede3dc8d0461840c5aa821c8c9a7eb3e.svg";
export { ForwardRef as ReactComponent };